import styled from 'styled-components';

export const LatestNewsFormWrapper = styled.div`
    background: transparent linear-gradient(292deg, #F7931E 0%, #33A7AE 100%) 0% 0% no-repeat padding-box;
    box-shadow: 0px 10px 30px #00000014;
    border-radius: 15px;
    padding: 20px;
    width: 100%;
    height: 100%;
    @media screen and (max-width:767px) {
        margin-top: 20px;
     }
    form{
        .input-group{
            margin-bottom: 21px;
            input::-webkit-outer-spin-button,
            input::-webkit-inner-spin-button {
              -webkit-appearance: none;
              margin: 0;
            }
            
            /* Firefox */
            input[type=number] {
              -moz-appearance: textfield;
            }
            .input-form-group{
                width: 100%;

                .form-control{
                    border-radius: 10px;
                    padding: 16px 30px;
                    font-family: "Jost", sans-serif;
                    font-size: 18px;
                    font-weight: 500;
                    line-height: 26px;
                }
            } 
        }
        .input-group-checkbox{
            display: flex;
            align-items: center;
            margin-bottom: 0px;

            .form-group{
                width: auto;
                .form-check{
                    display: flex;
                    align-items: center;
                    column-gap: 10px;

                    .form-check-input{
                        background-color: #00000080;
                        border-radius: 7px;
                        border: none;
                        width: 24px;
                        height: 24px;
                        margin-top: 0;
                        cursor: pointer;
                        &:focus{
                            box-shadow:none;
                        }
                        &:checked{
                            background-color: #000000;
                            background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="64" height="64"><path d="M0 0 C0.85205078 2.1003418 0.85205078 2.1003418 1 5 C-0.80325294 7.40324577 -2.50090052 9.3187865 -4.6328125 11.39453125 C-5.22166229 11.98674973 -5.81051208 12.5789682 -6.41720581 13.18913269 C-7.66605247 14.43768038 -8.92239781 15.67876572 -10.18554688 16.9128418 C-12.11628512 18.80396394 -14.01603216 20.72259867 -15.9140625 22.64648438 C-17.13106554 23.85592709 -18.3497619 25.06366877 -19.5703125 26.26953125 C-20.13823517 26.84443802 -20.70615784 27.41934479 -21.29129028 28.01167297 C-23.67403368 30.3111557 -25.38523675 31.87635232 -28.67773438 32.53857422 C-32.96271847 31.54481109 -35.38439865 28.37343246 -38.375 25.3125 C-39.35533203 24.37374023 -39.35533203 24.37374023 -40.35546875 23.41601562 C-42.08640997 21.67596419 -43.63883114 20.04290977 -45 18 C-44.9140625 15.04296875 -44.9140625 15.04296875 -44 13 C-42.25 12.296875 -42.25 12.296875 -40 12 C-38 13.328125 -38 13.328125 -36 15.25 C-33.42538131 17.68381923 -30.85072639 19.89610453 -28 22 C-27.36497559 21.33355469 -26.72995117 20.66710937 -26.07568359 19.98046875 C-23.70591971 17.50827298 -21.32308346 15.05030529 -18.93017578 12.60058594 C-17.89859451 11.53888314 -16.87246862 10.47185064 -15.85205078 9.39941406 C-14.3816479 7.85599215 -12.89249494 6.33299233 -11.3984375 4.8125 C-10.50817871 3.89082031 -9.61791992 2.96914063 -8.70068359 2.01953125 C-5.51430867 -0.36319279 -3.88711903 -0.43910972 0 0 Z " fill="%23FFFFFF" transform="translate(54,16)"/></svg>');
                            background-size: 65%;
                        }
                    }
                    .form-check-label{
                        color: #fff;
                        font-family: "Jost", sans-serif;
                        font-size: 18px;
                        font-weight: 500;
                        line-height: 26px;
                        margin-top: 2px;
                        cursor: pointer;
                    }
                }
            }
        }
        .btn-outline-success-blue {
            &.form-btn{
                box-shadow: 3px 5px 20px #00000033;
                border-radius: 10px;
                padding: 12px 36px;
                font-weight: 700;
            }
        }
    }
`;
export const LatestNewsTitle = styled.h3`
    display: flex;
    align-items: center;
    font-family: "Jost", sans-serif;
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;
    color: #fff;
    column-gap: 12px;
    margin-bottom: 20px;
`;

export const InputGroup = styled.div`
    margin-bottom: 21px;
    column-gap: 20px;
    flex-wrap: nowrap !important;
    
    @media screen and (max-width:575px) {
        flex-wrap: wrap !important;
        gap:15px;
     }

    .form-control{
        border-radius: 10px;
        padding: 16px 30px;
        font-family: "Jost", sans-serif;
        font-size: 18px;
        font-weight: 500;
        line-height: 26px;
        @media screen and (max-width:767px) {
            padding: 12px 25px !important;
        }
    }
`;
export const FormInputGroup = styled.div``;
export const FormGroupWrapper = styled.div``;